/**
 * Canonical registry of every /lab/* route in App.tsx.
 * When you add a lab route, add it here and to labItems in Lab.tsx.
 */
export interface LabRouteEntry {
  path: string;
  label: string;
}

export const LAB_ROUTES: LabRouteEntry[] = [
  { path: '/elevation/lab/architecture', label: 'System Architecture' },
  { path: '/elevation/lab/brand-guidelines-document', label: 'Brand Guidelines Document' },
  { path: '/elevation/lab/business-applications', label: 'Business Applications' },
  { path: '/elevation/lab/canon', label: 'Canon Engine (Lab URL)' },
  { path: '/elevation/lab/changing-unwanted-behaviors', label: 'Changing Unwanted Behaviors' },
  { path: '/elevation/lab/clarity-compass', label: 'Clarity Compass' },
  { path: '/elevation/lab/cognitive-bias', label: 'Cognitive Bias Audit' },
  { path: '/elevation/lab/connection-pathfinder', label: 'Connection Pathfinder' },
  { path: '/elevation/lab/consistency', label: 'Consistency Dashboard' },
  { path: '/elevation/lab/dashboard', label: 'Team Dashboard' },
  { path: '/elevation/lab/delegation-authority', label: 'Delegation Authority Lab' },
  { path: '/elevation/lab/docs', label: 'Documentation' },
  { path: '/elevation/lab/feature-flags', label: 'Feature Flags' },
  { path: '/elevation/lab/folder-creator', label: 'Folder Creator' },
  { path: '/elevation/lab/geometry-studio', label: 'Geometry Studio' },
  { path: '/elevation/lab/item-detail-second-pass', label: 'Item Detail, Second Pass' },
  { path: '/elevation/lab/item-detail-third-pass', label: 'Item Detail, Third Pass' },
  { path: '/elevation/lab/judgment-index', label: 'Judgment Index' },
  { path: '/elevation/lab/lexicon', label: 'Lexicon' },
  { path: '/elevation/lab/gold-rush-template', label: 'Gold Rush Template' },
  { path: '/elevation/lab/learning-pathways', label: 'Learning Pathways' },
  { path: '/elevation/lab/level-aware-thinking', label: 'Level-Aware Thinking' },
  { path: '/elevation/lab/logical-levels-story', label: 'DILTS Logical Levels' },
  { path: '/elevation/lab/m2-model-taxonomy', label: 'M2 Model Taxonomy' },
  { path: '/elevation/lab/mental-map', label: 'Mental Map' },
  { path: '/elevation/lab/metaphor-studio', label: 'Metaphor Studio' },
  { path: '/elevation/lab/morning-boot', label: 'Morning Boot Routine' },
  { path: '/elevation/lab/outcome-driver-generator', label: 'Outcome Driver Generator' },
  { path: '/elevation/lab/prioritization-archive/goals', label: 'Goal Verification' },
  { path: '/elevation/lab/prioritization-archive/security', label: 'Security Posture' },
  { path: '/elevation/lab/relationship-network', label: 'Relationship Network' },
  { path: '/elevation/lab/semantic-modes', label: 'Semantic Reading Modes' },
  { path: '/elevation/lab/sentence-builder', label: 'Sentence Builder' },
  { path: '/elevation/lab/shape-combinator', label: '3D Shape Combinator' },
  { path: '/elevation/lab/smart-suggestions', label: 'Smart Suggestions' },
  { path: '/elevation/lab/source-of-truth-checker', label: 'Source of Truth Checker' },
  { path: '/elevation/lab/team-exploration', label: 'Team Exploration' },
  { path: '/elevation/lab/tool-selector', label: 'Prioritization Tool Selector' },
  { path: '/elevation/lab/understanding-your-values', label: 'Understanding Your Values' },
  { path: '/elevation/lab/visual-verbal-integration', label: 'Visual-Verbal Integration' },
  { path: '/elevation/lab/youtube-search', label: 'YouTube Prioritization Search' },
  { path: 'http://localhost:3210', label: 'Visual Language Server' },
];

export const LAB_ROUTE_PATHS = new Set(LAB_ROUTES.map(r => r.path));

/** Paths registered in labItems (Lab.tsx) that must also appear in LAB_ROUTES. */
export function labRoutesMissingFromItems(itemPaths: Iterable<string>): string[] {
  const paths = new Set(itemPaths);
  return LAB_ROUTES.map(r => r.path).filter(path => !paths.has(path));
}
